import React, { memo, ReactNode } from 'react';
import cn from 'classnames';

import './TextField.scss';
import { WpIcon } from 'Wpds/components/icon';

type Props = {
  name?: string;
  type: string;
  value: string;
  labelMuted?: boolean;
  disabled?: boolean;
  placeholder?: string;
  iconClassName?: string;
  errorMessage?: string;
  label?: ReactNode | string;
  inputIcon?: ReactNode;
  className?: string;
  wrapperClassName?: string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

function TextField({
  name,
  type,
  value,
  onChange,
  labelMuted = true,
  disabled = false,
  placeholder = '',
  iconClassName,
  errorMessage,
  label,
  inputIcon = null,
  className = '',
  onFocus = () => null,
  onBlur = () => null,
  onKeyDown,
  wrapperClassName = 'mb-3',
}: Props) {
  return (
    <div className={`text-field d-flex flex-column w-100 ${wrapperClassName}`}>
      <span className={cn('text-field-label', { 'text-field-label--muted': labelMuted, 'text-danger': errorMessage })}>
        {label}
      </span>
      {iconClassName && (
        <span className={`text-field-icon `}>
          <WpIcon name={iconClassName}></WpIcon>
        </span>
      )}
      <input
        className={cn(`text-field form-control ${className}`, {
          'text-field-input--with-icon': iconClassName,
          'is-invalid': errorMessage,
        })}
        autoComplete="new-password"
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyDown={onKeyDown}
        onChange={onChange}
        disabled={disabled}
      />
      <div className="text-field-input-icon d-flex position-absolute">{inputIcon}</div>
      {errorMessage ? <p className="text-field-error text-danger">{errorMessage}</p> : null}
    </div>
  );
}

export default memo(TextField);
